<template>
  <v-list
    flat
    color="transparent"
    dense
  >
    <v-list-item
      v-for="item in result" :key="item.face_id"
    >
      <v-list-item-avatar
        size="55"
        color="grey darken-1"
        class="white--text"
      >
      <i>{{ item.similarity | number }}%</i>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          {{ item.person.name }} {{ item.person.last_name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ item.person.document_number }}
          <v-btn
            icon
            x-small
            @click="identifyPerson(item.person.id)"
          >
            <v-icon>mdi-eye-outline</v-icon>
          </v-btn>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import types from '@/types';

export default {

  props: {
    value: {
      type: Object,
      default() {},
    },
    imageUrl: {
      type: String,
      default: null,
    },
    controllerId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      result: {},
      loading: false,
      loaded: false,
    };
  },

  computed: {
    item: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    ...mapState(
      `${types.PERSON}`, [
        'person',
        'persons',
      ],
    ),
  },

  methods: {
    ...mapMutations({
      [types.SET_PERSONS]: `${types.PERSON}/${types.SET_PERSONS}`,
    }),
    ...mapActions({
      [types.SEARCH_BY_IMAGE]: `${types.PERSON}/${types.SEARCH_BY_IMAGE}`,
    }),
    imageUrlToBase64(url) {
      return fetch(url)
        .then((response) => response.blob()) // Convert to blob
        .then((blob) => new Promise((resolve) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result.split(',')[1]); // Get base64 string
          reader.readAsDataURL(blob);
        }));
    },
    async indentifyPerson() {
      this.loading = true;
      this[types.SEARCH_BY_IMAGE]({ image: await this.imageUrlToBase64(this.imageUrl) })
        .then((response) => {
          this.result = response.data;
        })
        .finally(() => {
          this.loading = false;
          this.loaded = true;
        });
    },
    identifyPerson(value) {
      this.$emit('identifyPerson', value, this.controllerId);
    },
  },

  mounted() {
    this.indentifyPerson();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/JimProfile.vue